import { createSlice } from "@reduxjs/toolkit"

const initialState = {
    status : 'idle',
    sessions: {
        demo: { started: false, sessionId: null },
        explore: { started: false, sessionId: null },
        comfort: { started: false, sessionId: null },
        open: { started: false, sessionId: null },
      }
}

export const gameStatusSlice = createSlice({
    name: 'gamestatus',
    initialState,
    reducers:{
        setGameStarted: (state, action) => {
            const { gameType, sessionId } = action.payload;
            if (state.sessions[gameType]) {
              state.sessions[gameType] = { started: true, sessionId };
            } else {
              console.error(`Invalid gameType: ${gameType}`);
            }
          },
        setGameReset: (state, action) => {
            const gameType = action.payload;
            state.sessions[gameType] = { started: false, sessionId: null };
          },
        setSessionId: (state, action) => {
            const { gameType, sessionId } = action.payload;
            if (state.sessions[gameType]) {
              state.sessions[gameType].sessionId = sessionId;
            }},
        setExplore:(state) =>{
            state.explore = true
        },
        setComfort:(state) =>{
            state.comfort = true
        },
        setOpen:(state) =>{
            state.open = true
        },
        setDemo:(state) =>{
            state.demo = true
        }
       
    }
})

export const selectGameStatus = (state) => state.gameStatus
export const {setGameStarted, setGameReset, setSessionId} = gameStatusSlice.actions
export default gameStatusSlice.reducer